import React, {PropsWithChildren} from 'react';
import AdminLayout from '../../pages/layouts/AdminLayout';
import {Box, CircularProgress, Typography} from '@mui/material';

type Props = PropsWithChildren<{}>;

export default function LoadingLayout({children}: Props) {
    return (
        <AdminLayout>
            <Box
                sx={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        mx: 1,
                        textAlign: 'center',
                    }}
                >
                    <Box
                        sx={{
                            mb: 3,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                    <Typography variant={'h1'} color={'primary'}>
                        {children}
                    </Typography>
                </Box>
            </Box>
        </AdminLayout>
    );
}
